/** Download rows as CSV with given headers. */
export function downloadCsv(
  filename: string,
  headers: { key: string; label: string }[],
  rows: Record<string, unknown>[],
) {
  const escape = (val: unknown) => {
    const s = val == null ? '' : String(val);
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const lines = [
    headers.map((h) => escape(h.label)).join(','),
    ...rows.map((row) => headers.map((h) => escape(row[h.key])).join(',')),
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function money(n: number | undefined | null) {
  return Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
}
